import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function LatestSection() {
  const sorted = [...movies].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime());

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 mt-14 md:mt-20 mb-14 md:mb-20">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">每日同步更新，精彩不错过</p>
        </div>
        <div className="flex items-center gap-2">
          <Link
            to="/category/dianying"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            全部
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
        {sorted.map((movie) => (
          <Link
            key={movie.id}
            to={`/article/${movie.id}`}
            className="group bg-background-100 border border-background-200/40 rounded-lg overflow-hidden hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
          >
            <div className="relative aspect-[2/3] overflow-hidden">
              <img
                src={movie.poster}
                alt={`${movie.title} - 91片库在线观看`}
                title={`${movie.title} ${movie.year} - 91片库高清资源`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-1.5 left-1.5 px-1.5 py-0.5 bg-primary-500 text-background-950 text-[10px] font-semibold rounded">
                {movie.quality}
              </div>
              <div className="absolute top-1.5 right-1.5 px-1.5 py-0.5 bg-background-950/70 backdrop-blur-sm text-foreground-200 text-[10px] rounded">
                {movie.rating}
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/90 to-transparent p-2">
                <span className="text-[10px] text-foreground-400">{movie.updateTime} 更新</span>
              </div>
            </div>
            <div className="p-2.5">
              <h3 className="text-xs md:text-sm font-medium text-foreground-200 group-hover:text-primary-400 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <p className="text-[10px] text-foreground-600 mt-1 line-clamp-1">{movie.tags.join(' / ')}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="flex justify-center mt-8">
        <Link
          to="/category/dianying"
          className="px-8 py-3 border border-background-300/50 rounded-full text-sm text-foreground-400 hover:text-primary-500 hover:border-primary-500/40 transition-all whitespace-nowrap cursor-pointer"
        >
          浏览全部资源 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>
    </section>
  );
}